import { PropsWithChildren } from "react"
import { Div } from "../../../../../components/div/Div"
import { CSSProp, styled } from "../../../../../styles/stitches.config"

type Props = {
  css?: CSSProp
}

export function CenterWrapper(props: PropsWithChildren<Props>) {
  const { children, css } = props
  return (
    <Div
      css={{
        margin: "0 auto",
        maxWidth: "608px",
        width: "90%",
        "@lg": {
          width: "100%",
        },
        ...css,
      }}
    >
      {children}
    </Div>
  )
}

export const ContainerLarge = styled(Div, {
  margin: "0 auto",
  maxWidth: "1000px",
  width: "90%",
  "@lg": {
    width: "100%",
  },
})
